import React, { useContext, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { CommonContext } from '../../component/common/context/commonContext'
import { useMountEffect } from 'primereact/hooks'
import PdaTitle from '../../component/common/PdaTitle'
import { IncomingDetailData } from '../../types/inbound'
import { Divider } from 'primereact/divider'
import { includeComma } from '../../utils/inputText'
import { Button } from 'primereact/button'
import IncomingDetailArrivalDialog from '../../component/incoming/dialog/IncomingDetailArrivalDialog' //입하처리
import moment from 'moment'
import IncomingDetailInboundDialog from '../../component/incoming/dialog/IncomingDetailInboundDialog'
import { useTranslation } from 'react-i18next' //적치=입고완료 처리
import { tokens } from 'locales/tokens'
import {
    translateInboundProgCd,
    translatePurchaseOrderInboundStatus
} from '../../utils/translateCodeUtils'

const IncomingDetail = () => {
    const location = useLocation()
    const { $alert, $toast, $http } = useContext(CommonContext)
    const { t } = useTranslation()
    const [incomingDetailData, setIncomingDetailData] = useState<IncomingDetailData>()
    const [arrivalVisible, setArrivalVisible] = useState<boolean>(false)
    const [isArrivalUpdate, setIsArrivalUpdate] = useState<boolean>(false)
    const [inboundVisible, setInboundVisible] = useState<boolean>(false)
    const [height, setHeight] = useState<number>(0)

    useMountEffect(() => {
        findInbound(location.state.inbId)
        setTimeout(() => getIncomingContentSize(), 1000)
    })

    const findInbound = async (inbId: number) => {
        const result = await $http().get(`/inbound/incoming-keep/${inbId}`)
        setIncomingDetailData(result)
    }

    const getFontColor = (inbProgCd: string) => {
        switch (inbProgCd) {
            case 'PI': // 부분입고
            case 'IW': // 입고대기
                return 'rdms-text-danger'
            case 'UC':
                return 'rdms-text-info'
            case 'IC':
                return 'rdms-text-success'
            default:
                return ''
        }
    }

    const onArrivalHide = (isChange: boolean) => {
        if (isChange) {
            findInbound(location.state.inbId)
        }

        setArrivalVisible(false)
    }

    const onArrivalOpen = (isUpdate: boolean) => {
        setIsArrivalUpdate(isUpdate)
        setArrivalVisible(true)
    }

    const onInboundHide = (isChange: boolean) => {
        if (isChange) {
            findInbound(location.state.inbId)
        }

        setInboundVisible(false)
    }

    const updateToUnreceived = async () => {

        const isConfirm = await $alert({
            icon: 'info',
            title: t(tokens.inbound.inbound_mi_processing),
            text: t(tokens.inbound.inbound_mi_processing_confirm_text),
            isConfirm: true,
        })

        if (isConfirm) {
            try {
                const inbId = location.state.inbId
                const prSeq = incomingDetailData?.prSeq
                const result = await $http().post(`/inbound/unreceived/${prSeq}`)
                if (result) {
                    $toast({
                        title: t(tokens.inbound.inbound_mi_processing),
                        text: t(tokens.inbound.inbound_mi_processing_success_text),
                        icon: 'success'
                    })
                    findInbound(inbId)
                }
            } catch (error) {
                $toast({
                    title: t(tokens.error.inbound_mi_error_title),
                    text: t(tokens.error.inbound_mi_error_text),
                    icon: 'error'
                })
            }
        }

    }

    const getIncomingContentSize = () => {
        const top = document.getElementsByClassName('pda-title')[0]
        const button = document.getElementsByClassName('incoming-button')[0]
        const title = document.getElementsByClassName('incoming-title')[0]
        const divider = document.getElementsByClassName('incoming-divider')[0]

        // setHeight(
        //     window.innerHeight -
        //     top.getBoundingClientRect().height -
        //     (button ? button.getBoundingClientRect().height : 0) -
        //     (title ? title.getBoundingClientRect().height : 0) -
        //     (divider ? divider.getBoundingClientRect().height : 0) -
        //     20,
        // )
    }

    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            window.history.pushState(null, '', window.location.href)
        }
        if (location.pathname === '/') {
            window.history.pushState(null, '', window.location.href)
            window.addEventListener('popstate', handlePopState)
        }
        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }, [location.pathname])

    // @ts-ignore
    // @ts-ignore
    return (
        <div style={{ overscrollBehaviorY: 'contain' }}>
            <PdaTitle title={t(tokens.common.incoming_schedule_details)} historyBack goToHome />
            {incomingDetailData && (
                <>
                    <div className="card grid m-3 p-1">
                        <div className="col-12 flex grid pb-0">
                            <div className="col-12 flex justify-content-center align-items-center">
                                <div className={`w-full text-right font-bold text-2xl ${getFontColor(incomingDetailData.inbProgCd)}`}>
                                    {incomingDetailData.inbProgCd === 'IW' && incomingDetailData.poInbSttCd === 'MI'? (
                                        <span>
                                            {translatePurchaseOrderInboundStatus(incomingDetailData.poInbSttCd, t)}
                                        </span>
                                    ) : (
                                        <span>
                                            {translateInboundProgCd(incomingDetailData.inbProgCd, t)}
                                        </span>
                                    )}
                                </div>
                            </div>
                            {/*<div className="col-8">
                                <div className="font-bold">입고 예정서</div>
                                <div className="text-sm mt-1">{incomingDetailData.poNo}</div>
                            </div>*/}
                        </div>
                        <Divider className="my-0 incoming-divider" />
                        {/* PDA화면에서 유통기한 부분 짤리므로 스크롤 적용 */}
                        <div className="col-12 overflow-y-auto" style={{ height: '300px' }}>
                            <div className="col-12 flex rdms-text-primary font-bold text-xl mt-2">
                                {t(tokens.inbound.inbound_center)} / {t(tokens.common.date_3)} / {t(tokens.common.hour)} / {t(tokens.common.total_plt_count)}
                            </div>
                            <div className="col-12 flex text-lg mt-0 pt-0">
                                {incomingDetailData.arvCenterNm} / {incomingDetailData.inbYmd} / {incomingDetailData.inbTimeCd} / {includeComma(incomingDetailData.goodsPltQty, '-')} PLT
                            </div>
                            <div className="col-12 flex rdms-text-primary font-bold text-xl mt-2">{t(tokens.common.product_name)} / {t(tokens.common.product_barcode)}</div>
                            <div className="col-12 flex text-lg mt-0 pt-0">{incomingDetailData.goodsNm} / {incomingDetailData.sysCd}</div>
                            <div className="col-12 flex rdms-text-primary font-bold text-xl mt-2">{t(tokens.common.invoice_no)} / {t(tokens.inbound.expected_lot_no)}</div>
                            <div className="col-12 flex text-lg mt-0 pt-0">
                                {incomingDetailData.custInbInvoiceNo} / {incomingDetailData.inbExpectedLotNo === null ? '-' : incomingDetailData.inbExpectedLotNo}
                            </div>
                            <div className="col-12 flex rdms-text-primary font-bold text-xl mt-2 grid py-0">
                                <div className="col-6">{t(tokens.common.expiration_date)}</div>
                                <div className="col-6">{t(tokens.inbound.expected_stock_quantity)}</div>
                            </div>
                            <div className="col-12 flex text-lg mt-0 py-0 grid">
                                {incomingDetailData.waitShelfs &&
                                    incomingDetailData.waitShelfs.map((shelf, index: number) => (
                                        <React.Fragment key={shelf.seq}>
                                            <div className="col-6 py-0">
                                                {incomingDetailData.shlfYn === 'Y' &&
                                                    (shelf.shlfYmd ? moment(shelf.shlfYmd).format('YY-MM-DD') : '-')}
                                            </div>
                                            <div className="col-6 py-0">
                                                {includeComma(shelf.goodsQty, '-')} {shelf.cnfrUnitCd}
                                            </div>
                                        </React.Fragment>
                                    ))}
                            </div>
                            <div className="col-12 flex rdms-text-primary font-bold text-xl mt-3">
                                {t(tokens.common.actual_inbound_count)} / {t(tokens.common.lot_no)}  / {t(tokens.common.expiration_date)}
                            </div>
                            <div className="col-12 text-lg mt-0 py-0">
                                {incomingDetailData.inbProgCd !== 'IW' && incomingDetailData.checkShelfs
                                    ? incomingDetailData.checkShelfs.map((shelf, index: number) => (
                                          <React.Fragment key={shelf.seq}>
                                              <div className="py-0">
                                                  {includeComma(shelf.goodsQty, '-')} {shelf.cnfrUnitCd}
                                                  {incomingDetailData.shlfYn === 'Y' && ' / ' + (shelf.lotNo ?? '-') + ' / ' + moment(shelf.shlfYmd).format('YY-MM-DD')}
                                              </div>
                                          </React.Fragment>
                                      ))
                                    : '-'}
                            </div>
                            <div className="col-12 flex rdms-text-primary font-bold text-xl mt-2">{t(tokens.common.accumulation_status)}</div>
                            <div className="col-12 flex- text-lg mt-0 pt-0">
                                {incomingDetailData.locationAccumulations &&
                                    incomingDetailData.locationAccumulations.map((locationAccumulation, index: number) => (
                                        <>
                                            <div className="col-12 py-0">
                                                {`${locationAccumulation.sectorNm}${locationAccumulation.bayId?.substring(1)} -
                                                    ${locationAccumulation.rackRowId?.padStart(2, '0')} - 
                                                    ${locationAccumulation.rackColId?.padStart(2, '0')} /
                                                    ${locationAccumulation.goodsQty} 
                                                    ${locationAccumulation.gdslsUnitCd}
                                                    `}
                                            </div>
                                        </>
                                    ))}
                            </div>
                            <div className="col-12 flex rdms-text-primary font-bold text-xl mt-2">{t(tokens.common.inbound_expected_significant)}</div>
                            <div className="col-12 flex text-lg mt-0 pt-0">
                                {incomingDetailData.rqstsTxt}
                            </div>
                            <div className="col-12 flex rdms-text-primary font-bold text-xl mt-2">{t(tokens.common.inbound_expected_goods_significant)}</div>
                            <div className="col-12 flex text-lg mt-0 pt-0">
                                {incomingDetailData.inbGoodsRemark}
                            </div>
                        </div>
                    </div>
                    <div className="px-3">
                        {incomingDetailData.inbProgCd === 'IW' && incomingDetailData.poInbSttCd !== 'MI' ? (
                            <>
                                <div className="grid">
                                    <div className="col-6">
                                        <Button
                                            label={t(tokens.inbound.inbound_mi_processing)}
                                            size="large"
                                            className="w-full p-button-warning"
                                            onClick={() => updateToUnreceived()}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <Button
                                            label={t(tokens.inbound.admission_processing)}
                                            size="large"
                                            className="w-full"
                                            onClick={() => onArrivalOpen(false)}
                                        />
                                    </div>
                                </div>
                            </>
                        ) : null}
                        {incomingDetailData.inbProgCd === 'UC' ? (
                            <>
                                <div className="grid">
                                    <div className="col-6">
                                        <Button
                                            label={t(tokens.common.receive_modification)}
                                            size="large"
                                            className="w-full p-button-warning"
                                            onClick={() => onArrivalOpen(true)}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <Button
                                            label={t(tokens.inbound.inbound_stack)}
                                            size="large"
                                            className="w-full"
                                            onClick={() => setInboundVisible(true)}
                                        />
                                    </div>
                                </div>
                            </>
                        ) : null}
                    </div>
                    {arrivalVisible && (
                        <IncomingDetailArrivalDialog
                            isUpdate={isArrivalUpdate}
                            visible={arrivalVisible}
                            onHide={(e) => onArrivalHide(e)}
                            data={incomingDetailData}
                        />
                    )}
                    {inboundVisible && (
                        <IncomingDetailInboundDialog visible={inboundVisible} onHide={(e) => onInboundHide(e)} data={incomingDetailData} />
                    )}
                </>
            )}
        </div>
    )
}

export default IncomingDetail
